import React, { useEffect, useState } from 'react';
import ItemModel from '../../data/item-model';
import HCNImages from '../../helpers/hcn-images';
import { Link, generatePath } from 'react-router-dom';
import './rootCategory-item.css';
import { useDispatch, useSelector } from 'react-redux';
import HCNLoader from '../../helpers/hcn-loader';
import InfoModal from '../info-modal';
import { toast } from 'react-toastify';
import { getTranslatedText } from '../../helpers/checkTranslations';
import { store } from '../../redux/store';
import Config from '../../Config';
import { LanguageBadges } from '../translations/language-badges';
import { selectProviderLocales } from '../../redux/provider/selectors';

const RootCategoryItem = ({ item, items, setItems }) => {
    const [show, setShow] = useState(false);
    const [infoMessage, setInfoMessage] = useState({ message: '', confirmation: false });
    const dispatch = useDispatch();
    const langs = useSelector(selectProviderLocales);

    useEffect(() => {
        if (infoMessage.confirmation) {
            HCNLoader.show(dispatch);
            ItemModel
                .deleteRootCategoryItem(item.id)
                .then(() => {
                    window.location.reload();
                    HCNLoader.hide(dispatch);
                })
                .catch(err => {
                    toast(err.message);
                    HCNLoader.hide(dispatch);
                });
        }

        return () => {
            setInfoMessage({});
        };
    }, [infoMessage.confirmation, item.id, dispatch]);

    const removeItem = () => {
        setShow(true);
        setInfoMessage({
            ...infoMessage,
            message: getTranslatedText('deleteItemWarning', store),
        });
    };

    const changeItemAvailability = (e) => {
        let updatedRootCategoryItem = {
            ...item,
            price: parseFloat(item.price2 ? item.price2 : item.price),
            filters: item.filters.map(f => f.id),
            modifiers: item.modifiers.map(m => m.id),
            taxes: item.taxes.map(t => t.name),
            upsells: item && item.upsells ? item.upsells.map(x => x.id) : [],
            available: e.target.checked,
        };

        HCNLoader.show(dispatch);
        ItemModel.updateItem(updatedRootCategoryItem, item.id)
            .then(() => {
                setItems(items.map(it => {
                    it.available = it.id === item.id ? updatedRootCategoryItem.available : it.available;
                    return it;
                }));
                HCNLoader.hide(dispatch);
            })
            .catch(err => {
                toast(err.message);
                HCNLoader.hide(dispatch);
            });
    };
    const changeItemHasQuantity = (e) => {
        // console.log('dsdsdds => ', e.target.checked);
        let updatedRootCategoryItem = {
            ...item,
            meta: {
                showQuantity: e.target.checked
            },
        };

        HCNLoader.show(dispatch);
        ItemModel.updateItem(updatedRootCategoryItem, item.id)
            .then(() => {
                setItems(items.map(it => {
                    it.meta.showQuantity = it.id === item.id ? updatedRootCategoryItem.meta.showQuantity : it.meta.showQuantity;
                    // console.log(it);
                    return it;
                }));
                HCNLoader.hide(dispatch);
            })
            .catch(err => {
                toast(err.message);
                HCNLoader.hide(dispatch);
            });
    };

    const hideModal = () => {
        setShow(false);
    };

    const generateLanguageLinkPath = (langCode) => {
        const path = generatePath(
            "/add-rootCategory-item/:langCode?/:itemId?",
            {
                langCode,
                itemId: item.id,
            }
        );

        return path;
    };

    return (
        <>
            <div className="grid-item custom-grid-1-1 grid-start-center">
                <InfoModal
                    setInfoMessage={setInfoMessage}
                    infoMessage={infoMessage}
                    hideModal={hideModal}
                    show={show}
                />
                {/*<span>*/}
                {/*    <svg width="32" height="8" viewBox="0 0 32 8" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                {/*        <g clipPath="url(#clip0_1_334)">*/}
                {/*            <path fillRule="evenodd" clipRule="evenodd" d="M30.0579 8H2.13217C1.79456 8 1.47078 7.85953 1.23205 7.60948C0.993319 7.35943 0.859205 7.02029 0.859205 6.66667C0.859205 6.31305 0.993319 5.97391 1.23205 5.72386C1.47078 5.47381 1.79456 5.33333 2.13217 5.33333H30.0579C30.3955 5.33333 30.7193 5.47381 30.958 5.72386C31.1968 5.97391 31.3309 6.31305 31.3309 6.66667C31.3309 7.02029 31.1968 7.35943 30.958 7.60948C30.7193 7.85953 30.3955 8 30.0579 8ZM30.0579 2.66667H2.13217C1.79456 2.66667 1.47078 2.52619 1.23205 2.27614C0.993319 2.02609 0.859205 1.68696 0.859205 1.33333C0.859205 0.979711 0.993319 0.640573 1.23205 0.390525C1.47078 0.140476 1.79456 0 2.13217 0H30.0579C30.3955 0 30.7193 0.140476 30.958 0.390525C31.1968 0.640573 31.3309 0.979711 31.3309 1.33333C31.3309 1.68696 31.1968 2.02609 30.958 2.27614C30.7193 2.52619 30.3955 2.66667 30.0579 2.66667Z" fill="#999999"/>*/}
                {/*        </g>*/}
                {/*        <defs>*/}
                {/*            <clipPath id="clip0_1_334">*/}
                {/*                <rect width="30.4733" height="8" fill="white" transform="matrix(-1 0 0 1 31.333 0)"/>*/}
                {/*            </clipPath>*/}
                {/*        </defs>*/}
                {/*    </svg>*/}
                {/*</span>*/}
            </div>
            <Link
                className="grid-item custom-grid-2-4 pointer"
                to={generateLanguageLinkPath(Config.DEFAULT_LANG_CODE)}
            >
                <div className="image-wrapper grid-flex">
                    <span className="image-container">
                        <img
                            alt="thumbnail"
                            src={HCNImages.getFullImageURL(
                                item.images && item.images[0],
                                item.images[0]?.thumbnail
                                    ? "thumbnail"
                                    : item.images[0]?.default
                                    ? "default"
                                    : "main"
                            )}
                        />
                        <span className="default-image-layer"></span>
                    </span>
                    <div className="margin-left-half">
                        <p>{item.name}</p>
                        <p className="text-small margin-top-half">
                            {item.description}
                        </p>
                    </div>
                </div>
            </Link>
            <div className="grid-item custom-grid-3-1">
                <LanguageBadges
                    items={langs.map((lang) => ({
                        content: lang.code,
                        isSupported: lang.code === Config.DEFAULT_LANG_CODE,
                        link: generateLanguageLinkPath(lang.code),
                    }))}
                />
            </div>
            <div className="grid-item custom-grid-3-2 grid-center">
                <div className="filters-wrapper flex-center">
                    {item.filters &&
                        item.filters.map((filter, index) => (
                            <span
                                className="filter-circle-small flex-center"
                                key={index}
                            >
                                {filter.acronym}
                            </span>
                        ))}
                </div>
            </div>
            <div className="grid-item custom-grid-4-2 grid-center">
                <p className="mods-price">
                    {item.price2 ? item.price2 : item.price}$
                </p>
            </div>
            <div className="grid-item custom-grid-5-2 grid-center">
                <label className="switch">
                    <input
                        type="checkbox"
                        value={""}
                        checked={
                            item &&
                            item.available !== null &&
                            item.available !== false
                                ? true
                                : false
                        }
                        onChange={changeItemAvailability}
                    />
                    <span className="slider round"></span>
                </label>
            </div>
            <div className="grid-item custom-grid-6-1 grid-end-center">
                <button onClick={removeItem} className="remove">
                    <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M27.3356 4.33917H2.07271C1.70054 4.33917 1.34361 4.49153 1.08044 4.76273C0.817278 5.03393 0.669434 5.40175 0.669434 5.78528C0.669434 6.16881 0.817278 6.53663 1.08044 6.80783C1.34361 7.07903 1.70054 7.23139 2.07271 7.23139H4.87992V24.5874C4.87992 25.7382 5.32352 26.8418 6.11314 27.6555C6.90276 28.4693 7.97371 28.9264 9.0904 28.9264H20.3179C21.4346 28.9264 22.5056 28.4693 23.2952 27.6555C24.0848 26.8418 24.5284 25.7382 24.5284 24.5874V7.23139H27.3356C27.7078 7.23139 28.0647 7.07903 28.3279 6.80783C28.591 6.53663 28.7389 6.16881 28.7389 5.78528C28.7389 5.40175 28.591 5.03393 28.3279 4.76273C28.0647 4.49153 27.7078 4.33917 27.3356 4.33917ZM13.3009 20.2484C13.3049 20.441 13.2716 20.6325 13.2029 20.8116C13.1342 20.9907 13.0314 21.1539 12.9007 21.2916C12.77 21.4293 12.6139 21.5387 12.4416 21.6133C12.2693 21.688 12.0842 21.7265 11.8973 21.7265C11.7104 21.7265 11.5253 21.688 11.353 21.6133C11.1807 21.5387 11.0246 21.4293 10.8939 21.2916C10.7631 21.1539 10.6604 20.9907 10.5917 20.8116C10.5229 20.6325 10.4896 20.441 10.4937 20.2484V13.0172C10.4896 12.8246 10.5229 12.6331 10.5917 12.454C10.6604 12.2748 10.7631 12.1116 10.8939 11.974C11.0246 11.8363 11.1807 11.7269 11.353 11.6522C11.5253 11.5775 11.7104 11.5391 11.8973 11.5391C12.0842 11.5391 12.2693 11.5775 12.4416 11.6522C12.6139 11.7269 12.77 11.8363 12.9007 11.974C13.0314 12.1116 13.1342 12.2748 13.2029 12.454C13.2716 12.6331 13.3049 12.8246 13.3009 13.0172V20.2484ZM18.9146 20.2484C18.9187 20.441 18.8854 20.6325 18.8167 20.8116C18.7479 20.9907 18.6452 21.1539 18.5145 21.2916C18.3837 21.4293 18.2276 21.5387 18.0553 21.6133C17.883 21.688 17.698 21.7265 17.511 21.7265C17.3241 21.7265 17.1391 21.688 16.9668 21.6133C16.7945 21.5387 16.6384 21.4293 16.5076 21.2916C16.3769 21.1539 16.2741 20.9907 16.2054 20.8116C16.1367 20.6325 16.1034 20.441 16.1074 20.2484V13.0172C16.1034 12.8246 16.1367 12.6331 16.2054 12.454C16.2741 12.2748 16.3769 12.1116 16.5076 11.974C16.6384 11.8363 16.7945 11.7269 16.9668 11.6522C17.1391 11.5775 17.3241 11.5391 17.511 11.5391C17.698 11.5391 17.883 11.5775 18.0553 11.6522C18.2276 11.7269 18.3837 11.8363 18.5145 11.974C18.6452 12.1116 18.7479 12.2748 18.8167 12.454C18.8854 12.6331 18.9187 12.8246 18.9146 13.0172V20.2484Z"
                            fill="white"
                        />
                        <path
                            d="M11.8964 2.89215H17.5109C17.8831 2.89215 18.24 2.7398 18.5032 2.46861C18.7663 2.19741 18.9142 1.8296 18.9142 1.44608C18.9142 1.06255 18.7663 0.694737 18.5032 0.423546C18.24 0.152354 17.8831 8.08214e-09 17.5109 0H11.8964C11.5243 8.08214e-09 11.1673 0.152354 10.9042 0.423546C10.641 0.694737 10.4932 1.06255 10.4932 1.44608C10.4932 1.8296 10.641 2.19741 10.9042 2.46861C11.1673 2.7398 11.5243 2.89215 11.8964 2.89215Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            <div className="hr-line-gray"></div>
            <div
                style={{
                    marginTop: 20,
                    display: "flex",
                    width: 200,
                    marginBottom: 20,
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
                data-info="rest_deliverytime"
            >
                <label htmlFor="provider_timezone">Show Quantity</label>
                <input
                    style={{ marginLeft: 20 }}
                    type="checkbox"
                    defaultChecked={item?.meta?.showQuantity}
                    onChange={changeItemHasQuantity}
                    // onClick={(event) => {
                    //     setProviderForm({
                    //         ...providerForm,
                    //         meta: {
                    //             ...providerForm.meta,
                    //             showCouponColumn: event.target.checked,
                    //         },
                    //     });
                    // }}
                />
            </div>
        </>
    );
};
export default RootCategoryItem;
